import { Alert, AlertTitle } from "@material-ui/lab"
import { DOCUMENT_STATES } from "lib"
import React from "react"
import { IRejectionCause } from "types"

interface Props {
    rejectionCause?: IRejectionCause
    status: number
    type: number
    isDocumentReceived?: boolean
}

const RejectionData = (props: Props) => {
    const { rejectionCause, status, type, isDocumentReceived } = props

    if (!rejectionCause) {
        return null
    }

    const isPending = status === DOCUMENT_STATES.pending || status === DOCUMENT_STATES.onHold
    const hideCode = isDocumentReceived && isPending

    const title = isPending && isDocumentReceived
        ? "Observación"
        : type === 7
        ? "Motivo de anulación"
        : "Motivo de rechazo"

    const severity = isPending && isDocumentReceived ? "warning" : "error"

    return (
        <React.Fragment>
            <Alert className="w-full" severity={severity} variant="outlined">
                <AlertTitle>{title}</AlertTitle>
                {hideCode ? null : <>{rejectionCause.rejectionCauseCode}<strong>{` - ${rejectionCause.name}`}</strong><br/></>}
                {rejectionCause.description !== undefined ? rejectionCause.description : ""}
            </Alert>
        </React.Fragment>
    )
}

export default RejectionData
